import config from "../Config/config";

const fetchCategories = async (setCategories) => {
  await fetch(`${config.serverBaseUrl}/category`, {
    credentials: "include",
  })
    .then((res) => res.json())
    .then((resJson) => setCategories(resJson.data.categories));
};

const fetchAllCategories = async (unit_id, activity_id, setCategories) => {
  try {
    const response = await fetch(
      `${config.serverBaseUrl}/category?unit_id=${unit_id}&activity_id=${activity_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      },
    );

    if (!response.ok) {
      console.log(response);
      throw new Error("Categories not found");
    }

    const resJson = await response.json();
    const data = resJson.data;
    setCategories(data.categories);
  } catch (error) {
    console.log(error);
  }
};

const fetchAllCategories2 = async (unit_id, activity_id) => {
  try {
    const response = await fetch(
      `${config.serverBaseUrl}/category?unit_id=${unit_id}&activity_id=${activity_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      },
    );

    if (!response.ok) {
      console.log(response);
      throw new Error("Categories not found");
    }

    const resJson = await response.json();
    const data = resJson.data;
    return data.categories;
  } catch (error) {
    console.log(error);
  }
};

const saveCategory = async (
  selectedCategory,
  setAlert,
  setIsEditingCat,
  setCategories,
) => {
  const method = selectedCategory.category_id ? "PUT" : "POST";
  const url = selectedCategory.category_id
    ? `${config.serverBaseUrl}/category/${selectedCategory.category_id}`
    : `${config.serverBaseUrl}/category`;

  try {
    const response = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(selectedCategory),
    });

    if (response.ok) {
      setIsEditingCat(false);
      fetchCategories(setCategories);
      setAlert({
        severity: "success",
        message: `Category saved!`,
      });
    } else {
      const data = await response.json();
      const error = data.error;
      setAlert({
        severity: "error",
        message: `Failed to save the category: ${error}`,
      });
    }
  } catch (error) {
    setAlert({
      severity: "error",
      message: `Failed to save the category: ${error}`,
    });
  }
};

const deleteCategory = async (id, setAlert, setCategories) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/category/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (response.ok) {
      fetchCategories(setCategories);
      setAlert({
        severity: "success",
        message: `Category deleted!`,
      });
    } else {
      const data = await response.json();
      const error = data.error;
      setAlert({
        severity: "error",
        message: `Failed to delete the category: ${error}`,
      });
    }
  } catch (error) {
    setAlert({
      severity: "error",
      message: `Failed to delete the category: ${error}`,
    });
  }
};

export {
  fetchCategories,
  saveCategory,
  deleteCategory,
  fetchAllCategories,
  fetchAllCategories2,
};
